// extracted by mini-css-extract-plugin
module.exports = {"page":"pages_page__2sOMX","loadingPage":"pages_loadingPage__1UG6n","body":"pages_body__1y0Lg","editor":"pages_editor__1G9XX","pageLoader":"pages_pageLoader__1bW51"};